module.exports = __webpack_public_path__ + "static/media/CreateNewCard3.105b2c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CreateNewCard3.png
// module id = 263
// module chunks = 0